import React from 'react';
import { Box, Typography, Alert, Paper, Button, Stack, IconButton } from '@mui/material';
import { EmojiEvents, Share, Facebook, X } from '@mui/icons-material';
import AdComponent from './ads';
import { handleNativeShare, handleFacebookShare, generateShareUrls } from '../utils/shareUtils';

interface GameCompletionProps {
  firstName?: string;
  middleName?: string;
  lastName?: string;
  score: number;
  isMobile: boolean;
}

const GameCompletion: React.FC<GameCompletionProps> = ({
  firstName,
  middleName,
  lastName,
  score,
  isMobile
}) => {
  const fullName = `${firstName || ''} ${middleName || ''} ${lastName || ''}`.trim();

  const renderMobileShare = () => (
    <Box sx={{ mb: 1.5 }}>
      <Button
        onClick={() => handleNativeShare(score)}
        variant="contained"
        size="large"
        startIcon={<Share />}
        sx={{
          bgcolor: 'primary.main',
          color: 'white',
          '&:hover': { bgcolor: 'primary.dark' },
          px: 3,
          py: 1
        }}
      >
        Share My Score
      </Button>
    </Box>
  );

  const renderDesktopShare = () => (
    <Stack justifyContent="center" alignItems="center" direction="row" spacing={2} sx={{ mb: 3 }}>
      <IconButton
        onClick={() => handleFacebookShare(score)}
        sx={{
          bgcolor: '#1877f2',
          color: 'white',
          '&:hover': { bgcolor: '#166fe5' }
        }}
      >
        <Facebook fontSize="large" />
      </IconButton>
      <IconButton
        href={generateShareUrls(score).twitter}
        target="_blank"
        rel="noopener noreferrer"
        sx={{
          bgcolor: '#000000',
          color: 'white',
          '&:hover': { bgcolor: '#333333' }
        }}
      >
        <X fontSize="large" />
      </IconButton>
      <IconButton
        onClick={() => handleNativeShare(score)}
        sx={{
          bgcolor: 'primary.main',
          color: 'white',
          '&:hover': { bgcolor: 'primary.dark' }
        }}
      >
        <Share fontSize="large" />
      </IconButton>
    </Stack>
  );

  return (
    <Paper elevation={3} sx={{ px: { xs: 0.5, sm: 0.4, md: 1, lg: 3 }, py: { xs: 0.5, sm: 0.4, md: 1, lg: 3 }, mb: 2, display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
      <Alert
        severity="success"
        icon={false}
        sx={{
          border: 'none',
          textAlign: 'center',
          width: '100%',
          '& .MuiAlert-message': {
            display: 'flex',
            alignItems: 'center',
            flexDirection: 'column',
            textAlign: 'center',
            width: '100%'
          }
        }}
      >
        <Typography
          variant="h4"
          gutterBottom
          sx={{
            mb: { xs: 0.5, sm: 0.75, md: 1 },
            fontSize: { xs: '1.5rem', sm: '1.75rem', md: '2rem', lg: '2.125rem' }
          }}
        >
          Congratulations!
        </Typography>
        <Typography
          variant="h6"
          sx={{
            mb: { xs: 0.75, sm: 1, md: 1.5, lg: 2 },
            fontSize: { xs: '0.9rem', sm: '1rem', md: '1.15rem', lg: '1.25rem' }
          }}
        >
          You correctly guessed: <strong>{fullName}</strong>
        </Typography>
        <Typography
          variant="h6"
          sx={{
            mb: { xs: 0.75, sm: 1, md: 1.5, lg: 2 },
            fontSize: { xs: '0.9rem', sm: '1rem', md: '1.15rem', lg: '1.25rem' }
          }}
        >
          Score: <strong>{score}</strong>
        </Typography>
        {isMobile ? renderMobileShare() : renderDesktopShare()}
        <AdComponent />
      </Alert>
    </Paper>
  );
};

export default GameCompletion;